import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import Modal from '../../components/modal';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useAuthorization } from '../../context/authorizationContext';
import { useUsers } from '../../context/usersContext';
import './visitantes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faTrash,
  faEye,
  faPen,
  faIdCard,
  faShieldHalved,
  faUserGroup,
  faLocationDot,
  faPhone,
  faFileLines,
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { normalizeUnitId } from '../../utils/unitScope';
import { TYPE_OAB_OPTIONS, getTypeOabLabel } from '../../utils/typeOab';
import {
  getVisitorDisplayStatus,
  normalizeVisitorAuthStatus,
} from '../../utils/visitorStatus';
import BinaryImage from '../../components/BinaryImage';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField, resolveThumbnailField } from '../../utils/binaryFile';

const SectionTitle = ({ icon, children }) => (
  <h3 className="visitor-card-title">
    <span className="visitor-card-icon">
      <FontAwesomeIcon icon={icon} />
    </span>
    {children}
  </h3>
);

// Perfis externos somente-leitura. Ao liberar esta tela pra outro perfil externo, ele já entra só leitura.
const EXTERNAL_PROFILE_GROUPS = ['TJPI', 'POLÍCIA MILITAR / POLÍCIA CIVIL', 'DEFENSORIA', 'MPPI'];

const normalizePermissionText = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();

const isThreeByFourLabel = (value) => {
  const normalized = normalizePermissionText(value).replace(/\s/g, '');
  return normalized.includes('3X4');
};

function VisitantesDetalhes() {
  const { visitorId } = useParams();
  const navigate = useNavigate();
  const {
    getVisitorById,
    updateVisitor,
    listVisitorFiles,
    listVisitorImages,
    createVisitorImage,
    updateVisitorImage,
    createVisitorFile,
    getInternalById,
    updateVisitorFileActive,
    listVisitorAddresses,
    createVisitorAddress,
    updateVisitorAddress,
    listVisitorPhone,
    createVisitorPhone,
    updateVisitorPhone,
    listVisitorRelationships,
    createVisitorRelationship,
    updateVisitorRelationship,
    respondVisitorAuthorization,
  } = useInternals();
  const {
    listColorEthnicity,
    listMaritalStatus,
    listGender,
    listSexualOrientation,
    listCountry,
    listCity,
    listTypeVisitor,
    listTypeFiles,
    listTypeRelationInternal,
  } = useAuxiliaries();
  const { listAuthorizations } = useAuthorization();
  const { userInfo, userUnitIds, effectiveUnitId } = useUsers();

  const [visitor, setVisitor] = useState(null);
  const [visitorFiles, setVisitorFiles] = useState([]);
  const [visitorImages, setVisitorImages] = useState([]);
  const [authorizationHistory, setAuthorizationHistory] = useState([]);
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isLoadingAuthorizationHistory, setIsLoadingAuthorizationHistory] = useState(false);

  const [isGeneralModalOpen, setIsGeneralModalOpen] = useState(false);
  const [isSavingGeneral, setIsSavingGeneral] = useState(false);
  const [isRelationshipModalOpen, setIsRelationshipModalOpen] = useState(false);
  const [isSavingRelationships, setIsSavingRelationships] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [isSavingDocument, setIsSavingDocument] = useState(false);
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
  const [isSavingPhoto, setIsSavingPhoto] = useState(false);
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreviewUrl, setPhotoPreviewUrl] = useState(null);
  const [internalUnitMap, setInternalUnitMap] = useState({});
  const [relationshipInternals, setRelationshipInternals] = useState([]);
  const [typeVisitorOptions, setTypeVisitorOptions] = useState([]);
  const [selectedTypeVisitorIds, setSelectedTypeVisitorIds] = useState([]);
  const [typeFileOptions, setTypeFileOptions] = useState([]);
  const [documentForm, setDocumentForm] = useState({
    type_file: '',
    file: null,
  });
  const [visitorAddresses, setVisitorAddresses] = useState([]);
  const [isLoadingAddresses, setIsLoadingAddresses] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [isSavingAddress, setIsSavingAddress] = useState(false);
  const [addressFormData, setAddressFormData] = useState({
    neighborhood: '',
    public_place: '',
    complement: '',
    cep: '',
    main: false,
    city: '',
  });
  const [addressCityQuery, setAddressCityQuery] = useState('');
  const [addressCityDisplay, setAddressCityDisplay] = useState('');
  const [addressFilteredCities, setAddressFilteredCities] = useState([]);
  const [viewingAddress, setViewingAddress] = useState(null);
  const [isAddressViewModalOpen, setIsAddressViewModalOpen] = useState(false);

  const [visitorPhones, setVisitorPhones] = useState([]);
  const [isLoadingPhones, setIsLoadingPhones] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [editingPhoneId, setEditingPhoneId] = useState(null);
  const [isSavingPhone, setIsSavingPhone] = useState(false);
  const [phoneFormData, setPhoneFormData] = useState({
    name: '',
    title: '',
    number: '',
  });

  const [colorOptions, setColorOptions] = useState([]);
  const [maritalStatusOptions, setMaritalStatusOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [sexualOrientationOptions, setSexualOrientationOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [, setCountrySearchQuery] = useState('');
  const [citySearchQuery, setCitySearchQuery] = useState('');
  const [shouldSearchCity, setShouldSearchCity] = useState(false);
  const [typeRelationOptions, setTypeRelationOptions] = useState([]);
  const [pendingInternal, setPendingInternal] = useState(null);
  const [pendingTypeRelation, setPendingTypeRelation] = useState('');
  const [existingVisitorRelationships, setExistingVisitorRelationships] = useState([]);
  const [visitorRelationshipMap, setVisitorRelationshipMap] = useState({});
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authForm, setAuthForm] = useState({
    social_worker_authorization: 'Autorizado',
    social_worker_motive: '',
  });
  const [authErrors, setAuthErrors] = useState({});
  const [isSavingAuth, setIsSavingAuth] = useState(false);
  const generalFields = [
    'name',
    'social_name',
    'date_of_birth',
    'email',
    'nationality',
    'naturalness',
    'gender',
    'sexual_orientation',
    'color_or_ethnicity',
    'marital_status',
    'registration',
    'cpf',
    'rg',
    'oab',
    'uf_oab',
    'type_oab',
    'virtual',
  ];

  const mapVisitorInternals = useCallback((internals = []) => {
    return internals.map((internal) => ({
      id: internal.id,
      name: internal.name,
      cpf: internal.cpf || internal.document || '',
      type_relationship:
        internal.type_relationship ||
        internal.type_relationship_name ||
        internal.relationship ||
        '',
    }));
  }, []);

  const normalizedGroups =
    userInfo?.groups?.map((group) => normalizePermissionText(group)) || [];
  // Perfil externo (hoje só a Polícia acessa esta tela) só consulta, como gerente/diretores/DUAP,
  // e abre a ficha externa do interno (a completa não é liberada pra ele).
  const isExternalProfile = EXTERNAL_PROFILE_GROUPS.some((group) => normalizedGroups.includes(normalizePermissionText(group)));
  const isUnitManagerViewOnly = isExternalProfile || ['GERENTE DE UNIDADE', 'DIRETORES', 'DUAP'].some((group) => normalizedGroups.includes(group));

  const isServicoSocial = normalizedGroups.includes(
    normalizePermissionText('SERVICO SOCIAL')
  );

  const extractInternalId = useCallback((internal) => {
    if (internal === null || internal === undefined) return null;
    if (typeof internal === 'object') return internal.id ?? null;
    return internal;
  }, []);

  const extractInternalUnitId = useCallback((internal) => (
    normalizeUnitId(
      internal?.unit?.id ??
      internal?.unit_id ??
      internal?.unit ??
      internal?.cell?.pavilion?.unit?.id ??
      internal?.cell?.pavilion?.unit ??
      internal?.pavilion?.unit?.id ??
      internal?.pavilion?.unit
    )
  ), []);

  const loadVisitor = useCallback(async () => {
    if (!visitorId) {
      setVisitor(null);
      return;
    }

    setIsLoading(true);
    try {
      const response = await getVisitorById(visitorId);
      const visitorData = Array.isArray(response) ? response[0] : response;
      setVisitor(visitorData || null);
    } catch (error) {
      console.error('Erro ao carregar visitante:', error);
      setVisitor(null);
    } finally {
      setIsLoading(false);
    }
  }, [getVisitorById, visitorId]);

  useEffect(() => {
    loadVisitor();
  }, [loadVisitor]);

  useEffect(() => {
    const internals = Array.isArray(visitor?.internals) ? visitor.internals : [];
    const unresolvedInternalIds = [
      ...new Set(
        internals
          .map((internal) => {
            const directUnitId = extractInternalUnitId(internal);
            if (directUnitId !== null) return null;
            return extractInternalId(internal);
          })
          .filter((internalId) => internalId !== null && internalId !== undefined && String(internalId).trim() !== '')
      ),
    ].filter(
      (internalId) => !Object.prototype.hasOwnProperty.call(internalUnitMap, String(internalId))
    );

    if (!unresolvedInternalIds.length) {
      return;
    }

    let cancelled = false;

    const resolveInternalUnits = async () => {
      const updates = {};

      await Promise.all(
        unresolvedInternalIds.map(async (internalId) => {
          try {
            const internalDetails = await getInternalById(internalId);
            const resolvedUnitId = normalizeUnitId(
              internalDetails?.unit?.id ??
              internalDetails?.unit_id ??
              internalDetails?.unit ??
              internalDetails?.cell?.pavilion?.unit?.id ??
              internalDetails?.cell?.pavilion?.unit ??
              internalDetails?.pavilion?.unit?.id ??
              internalDetails?.pavilion?.unit
            );
            updates[String(internalId)] = resolvedUnitId;
          } catch (error) {
            updates[String(internalId)] = null;
          }
        })
      );

      if (!cancelled && Object.keys(updates).length > 0) {
        setInternalUnitMap((prev) => ({
          ...prev,
          ...updates,
        }));
      }
    };

    resolveInternalUnits();

    return () => {
      cancelled = true;
    };
  }, [visitor, getInternalById, extractInternalId, extractInternalUnitId, internalUnitMap]);

  const loadVisitorFiles = useCallback(async () => {
    if (!visitorId) {
      setVisitorFiles([]);
      return;
    }

    setIsLoadingFiles(true);
    try {
      const response = await listVisitorFiles(visitorId);
      const files = Array.isArray(response)
        ? response
        : response?.results || response?.message || [];

      const parsedFiles = Array.isArray(files) ? files : [];
      const currentVisitorId = String(visitorId || '');

      const extractFileVisitorId = (item) =>
        item?.visitor ||
        item?.visitor_id ||
        item?.person ||
        item?.person_id ||
        item?.visitor?.id ||
        item?.person?.id ||
        null;

      const hasVisitorReference = parsedFiles.some((item) => {
        const reference = extractFileVisitorId(item);
        return reference !== null && reference !== undefined && String(reference) !== '';
      });

      const scopedFiles = hasVisitorReference
        ? parsedFiles.filter((item) => String(extractFileVisitorId(item)) === currentVisitorId)
        : parsedFiles;

      setVisitorFiles(scopedFiles);
    } catch (error) {
      console.error('Erro ao carregar documentos do visitante:', error);
      setVisitorFiles([]);
    } finally {
      setIsLoadingFiles(false);
    }
  }, [listVisitorFiles, visitorId]);

  useEffect(() => {
    loadVisitorFiles();
  }, [loadVisitorFiles]);

  const loadVisitorAddresses = useCallback(async () => {
    if (!visitorId) {
      setVisitorAddresses([]);
      return;
    }
    setIsLoadingAddresses(true);
    try {
      const response = await listVisitorAddresses(visitorId);
      const addresses = Array.isArray(response) ? response : response?.results || [];
      setVisitorAddresses(addresses);
    } catch (error) {
      console.error('Erro ao carregar endereços do visitante:', error);
      setVisitorAddresses([]);
    } finally {
      setIsLoadingAddresses(false);
    }
  }, [listVisitorAddresses, visitorId]);

  useEffect(() => {
    loadVisitorAddresses();
  }, [loadVisitorAddresses]);

  const loadVisitorPhones = useCallback(async () => {
    if (!visitorId) {
      setVisitorPhones([]);
      return;
    }
    setIsLoadingPhones(true);
    try {
      const response = await listVisitorPhone(visitorId);
      const phones = Array.isArray(response) ? response : response?.results || [];
      setVisitorPhones(phones);
    } catch (error) {
      console.error('Erro ao carregar telefones do visitante:', error);
      setVisitorPhones([]);
    } finally {
      setIsLoadingPhones(false);
    }
  }, [listVisitorPhone, visitorId]);

  useEffect(() => {
    loadVisitorPhones();
  }, [loadVisitorPhones]);

  const loadVisitorRelationships = useCallback(async () => {
    if (!visitorId) {
      setVisitorRelationshipMap({});
      return;
    }
    try {
      const data = await listVisitorRelationships(visitorId);
      const records = Array.isArray(data) ? data : [];
      const map = {};
      records.forEach((rel) => {
        const internalId = rel?.internal?.id ?? rel?.internal;
        if (internalId) map[String(internalId)] = rel;
      });
      setVisitorRelationshipMap(map);
    } catch (error) {
      setVisitorRelationshipMap({});
    }
  }, [listVisitorRelationships, visitorId]);

  useEffect(() => {
    loadVisitorRelationships();
  }, [loadVisitorRelationships]);

  const loadVisitorImages = useCallback(async () => {
    if (!visitorId) {
      setVisitorImages([]);
      return;
    }

    try {
      const response = await listVisitorImages(visitorId);
      const images = Array.isArray(response)
        ? response
        : response?.results || response?.message || [];

      const parsedImages = Array.isArray(images) ? images : [];
      const currentVisitorId = String(visitorId || '');

      const extractImageVisitorId = (item) =>
        item?.visitor ||
        item?.visitor_id ||
        item?.person ||
        item?.person_id ||
        item?.visitor?.id ||
        item?.person?.id ||
        null;

      const hasVisitorReference = parsedImages.some((item) => {
        const reference = extractImageVisitorId(item);
        return reference !== null && reference !== undefined && String(reference) !== '';
      });

      const scopedImages = hasVisitorReference
        ? parsedImages.filter((item) => String(extractImageVisitorId(item)) === currentVisitorId)
        : parsedImages;

      setVisitorImages(scopedImages);
    } catch (error) {
      console.error('Erro ao carregar imagens do visitante:', error);
      setVisitorImages([]);
    }
  }, [listVisitorImages, visitorId]);

  useEffect(() => {
    loadVisitorImages();
  }, [loadVisitorImages]);

  const loadAuthorizationHistory = useCallback(async () => {
    if (!visitorId) {
      setAuthorizationHistory([]);
      return;
    }

    setIsLoadingAuthorizationHistory(true);
    try {
      const response = await listAuthorizations(undefined, {
        visitor: visitorId,
        ordering: '-date',
        limit: 100,
      });

      const records = Array.isArray(response)
        ? response
        : Array.isArray(response?.results)
          ? response.results
          : [];

      const currentVisitorId = String(visitorId);
      const extractHistoryVisitorId = (item) =>
        item?.visitor ||
        item?.visitor_id ||
        item?.visitor?.id ||
        null;

      const scopedRecords = records.filter((item) => (
        String(extractHistoryVisitorId(item) || '') === currentVisitorId
      ));

      scopedRecords.sort((a, b) => (
        new Date(b?.date || 0).getTime() - new Date(a?.date || 0).getTime()
      ));

      setAuthorizationHistory(scopedRecords);
    } catch (error) {
      console.error('Erro ao carregar histórico de autorizações do visitante:', error);
      setAuthorizationHistory([]);
    } finally {
      setIsLoadingAuthorizationHistory(false);
    }
  }, [listAuthorizations, visitorId]);

  useEffect(() => {
    loadAuthorizationHistory();
  }, [loadAuthorizationHistory]);

  useEffect(() => {
    setRelationshipInternals(mapVisitorInternals(visitor?.internals || []));
  }, [visitor, mapVisitorInternals]);

  useEffect(() => {
    const selectedTypeIds = Array.isArray(visitor?.type_visitor)
      ? visitor.type_visitor
        .map((type) => Number(type?.id))
        .filter((id) => !Number.isNaN(id))
      : [];
    setSelectedTypeVisitorIds(selectedTypeIds);
  }, [visitor]);

  useEffect(() => {
    const fetchAuxiliaryData = async () => {
      try {
        const [
          colors,
          maritalStatuses,
          genders,
          sexualOrientations,
          countries,
          typeVisitors,
          typeFiles,
          typeRelations,
        ] = await Promise.all([
          listColorEthnicity?.(),
          listMaritalStatus?.(),
          listGender?.(),
          listSexualOrientation?.(),
          listCountry?.(),
          listTypeVisitor?.(),
          listTypeFiles?.(),
          listTypeRelationInternal?.(),
        ]);

        setColorOptions(colors?.results || colors || []);
        setMaritalStatusOptions(maritalStatuses?.results || maritalStatuses || []);
        setGenderOptions(genders?.results || genders || []);
        setSexualOrientationOptions(sexualOrientations?.results || sexualOrientations || []);
        setCountryOptions(countries?.results || countries || []);
        setTypeVisitorOptions(typeVisitors?.results || typeVisitors || []);
        setTypeFileOptions(typeFiles?.results || typeFiles || []);
        setTypeRelationOptions(Array.isArray(typeRelations) ? typeRelations : typeRelations?.results || []);
      } catch (error) {
        console.error('Erro ao carregar dados auxiliares', error);
      }
    };

    fetchAuxiliaryData();
  }, [listColorEthnicity, listMaritalStatus, listGender, listSexualOrientation, listCountry, listTypeVisitor, listTypeFiles, listTypeRelationInternal]);

  useEffect(() => {
    if (visitor) {
      setEditData(visitor);
      setIsGeneralModalOpen(false);
    }
  }, [visitor]);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const selectFields = [
      'color_or_ethnicity',
      'gender',
      'marital_status',
      'sexual_orientation',
    ];
    const upperNoAccentFields = new Set([
      'name',
      'social_name',
      'email',
      'nationality',
      'naturalness',
      'registration',
      'cpf',
      'rg',
      'oab',
    ]);
    const parsedValue =
      type === 'checkbox'
        ? checked
        : name === 'uf_oab'
          ? normalizeUpperNoAccent(value).replace(/[^A-Z]/g, '').slice(0, 2)
          : selectFields.includes(name)
            ? value === '' ? '' : Number(value)
            : upperNoAccentFields.has(name)
              ? normalizeUpperNoAccent(value)
              : value;
    setEditData((prev) => ({
      ...prev,
      [name]: parsedValue,
    }));
  };

  const formatDateForInput = (value) => {
    if (!value) return '';
    if (typeof value === 'string') {
      if (value.includes('T')) {
        return value.split('T')[0];
      }
      return value;
    }
    try {
      return new Date(value).toISOString().split('T')[0];
    } catch (error) {
      return '';
    }
  };

  const formatCpfDisplay = (value) => {
    if (!value) return '-';
    const numbers = value.replace(/\D/g, '').slice(0, 11);
    if (!numbers) return '-';
    return numbers
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  };

  const formatDateTimePtBr = (value) => {
    if (!value) return '-';
    try {
      return new Date(value).toLocaleString('pt-BR');
    } catch (error) {
      return '-';
    }
  };


  const resolveVisitorFileName = (fileItem, index) =>
    fileItem?.type ||
    fileItem?.type_name ||
    fileItem?.type?.name ||
    fileItem?.description ||
    fileItem?.name ||
    fileItem?.filename ||
    `Documento ${index + 1}`;

  const resolveVisitorImageType = (imageItem) =>
    imageItem?.type ||
    imageItem?.type_name ||
    imageItem?.type?.name ||
    imageItem?.type_image_name ||
    imageItem?.type_image?.name ||
    imageItem?.type_image ||
    imageItem?.description ||
    '';

  // Foto principal do visitante: registro com arquivo + recurso de onde ele sai pela rota binary.
  const visitorMainPhoto = useMemo(() => {
    const toVisitorImagePhoto = (item) => ({
      resource: BINARY_RESOURCES.visitorImage,
      id: item.id,
      field: resolveThumbnailField(item),
    });

    const normalizedImages = (visitorImages || []).map((item) => ({
      ...item,
      hasPicture: hasBinaryField(item, 'picture'),
      resolvedType: resolveVisitorImageType(item),
      isMain: Boolean(item?.main || item?.is_main || item?.principal),
    }));

    const mainThreeByFour = normalizedImages.find(
      (item) => item.hasPicture && item.isMain && isThreeByFourLabel(item.resolvedType)
    );
    if (mainThreeByFour) return toVisitorImagePhoto(mainThreeByFour);

    const anyThreeByFour = normalizedImages.find(
      (item) => item.hasPicture && isThreeByFourLabel(item.resolvedType)
    );
    if (anyThreeByFour) return toVisitorImagePhoto(anyThreeByFour);

    const anyMain = normalizedImages.find((item) => item.hasPicture && item.isMain);
    if (anyMain) return toVisitorImagePhoto(anyMain);

    const rawVisitorImage = visitor?.image;
    if (rawVisitorImage && typeof rawVisitorImage === 'object' && hasBinaryField(rawVisitorImage, 'picture')) {
      return toVisitorImagePhoto(rawVisitorImage);
    }

    const fileThreeByFour = (visitorFiles || []).find((fileItem) =>
      hasBinaryField(fileItem, 'file') && isThreeByFourLabel(resolveVisitorFileName(fileItem, 0))
    );
    if (fileThreeByFour) {
      return { resource: BINARY_RESOURCES.visitorFile, id: fileThreeByFour.id, field: 'file' };
    }

    return null;
  }, [visitor, visitorFiles, visitorImages]);

  const resolveOptionLabel = (options, value) => {
    if (value === null || value === undefined || value === '') return '-';
    const rawValue =
      typeof value === 'object'
        ? value.id ?? value.name ?? ''
        : value;
    const match =
      options.find(
        (option) =>
          String(option.id) === String(rawValue) ||
          (option.name &&
            option.name.toLowerCase() === String(value).toLowerCase())
      ) || null;
    if (match) {
      return match.name || match.label || '-';
    }
    if (typeof value === 'object') {
      return value.name || value.label || '-';
    }
    return rawValue || '-';
  };

  const resolveOptionId = (options, value) => {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'object') {
      if (value.id) return value.id;
      if (value.name) {
        const match = options.find(
          (option) =>
            option.name &&
            option.name.toLowerCase() === value.name.toLowerCase()
        );
        if (match) return match.id;
        return value.name;
      }
    }
    const matchById = options.find(
      (option) => String(option.id) === String(value)
    );
    if (matchById) return matchById.id;

    const matchByName = options.find(
      (option) =>
        option.name &&
        option.name.toLowerCase() === String(value).toLowerCase()
    );
    return matchByName ? matchByName.id : value;
  };

  const getVisitorUnitIds = useCallback((visitorData) => {
    const internals = Array.isArray(visitorData?.internals) ? visitorData.internals : [];
    const unitIds = new Set();

    internals.forEach((internal) => {
      const directUnitId = extractInternalUnitId(internal);
      if (directUnitId !== null) {
        unitIds.add(String(directUnitId));
        return;
      }

      const internalId = extractInternalId(internal);
      if (internalId === null || internalId === undefined) return;

      const mappedUnitId = normalizeUnitId(internalUnitMap[String(internalId)]);
      if (mappedUnitId !== null) {
        unitIds.add(String(mappedUnitId));
      }
    });

    return unitIds;
  }, [extractInternalId, extractInternalUnitId, internalUnitMap]);

  const isFamilyTypeVisitor = useMemo(() => {
    const typeVisitors = Array.isArray(visitor?.type_visitor) ? visitor.type_visitor : [];
    return typeVisitors.some((typeVisitor) => {
      const label =
        typeVisitor?.name ||
        typeVisitor?.type ||
        (typeof typeVisitor === 'string' ? typeVisitor : '');
      return normalizePermissionText(label) === 'FAMILIAR';
    });
  }, [visitor?.type_visitor]);

  const canManageVisitorByUnit = useMemo(() => {
    if (!visitor) {
      return false;
    }

    if (userInfo?.is_superuser) {
      return true;
    }

    const selectedUnit = normalizeUnitId(effectiveUnitId);
    const allowedUnits = selectedUnit !== null
      ? new Set([String(selectedUnit)])
      : new Set(
        (userUnitIds || [])
          .map((unitId) => normalizeUnitId(unitId))
          .filter((unitId) => unitId !== null)
          .map((unitId) => String(unitId))
      );

    if (!allowedUnits.size) {
      return false;
    }

    const internals = Array.isArray(visitor?.internals) ? visitor.internals : [];
    if (!internals.length) {
      return !isFamilyTypeVisitor;
    }

    const visitorUnitIds = getVisitorUnitIds(visitor);
    if (!visitorUnitIds.size) {
      return false;
    }

    return [...visitorUnitIds].some((unitId) => allowedUnits.has(String(unitId)));
  }, [visitor, userInfo, userUnitIds, effectiveUnitId, getVisitorUnitIds, isFamilyTypeVisitor]);

  const canEditVisitorData = !isUnitManagerViewOnly && canManageVisitorByUnit;

  const canEditRelationships =
    !isUnitManagerViewOnly &&
    (isServicoSocial || canManageVisitorByUnit);

  const canShowAuthorizationAction = isServicoSocial && isFamilyTypeVisitor && canManageVisitorByUnit;

  const handleOpenAuthModal = () => {
    if (!canShowAuthorizationAction || !visitor) return;
    setAuthForm({
      social_worker_authorization: visitor.social_worker_authorization || 'Sem resposta',
      social_worker_motive: visitor.social_worker_motive || '',
    });
    setAuthErrors({});
    setIsAuthModalOpen(true);
  };

  const closeAuthModal = () => {
    setAuthErrors({});
    setIsAuthModalOpen(false);
  };

  const handleAuthChange = (event) => {
    const { name, value } = event.target;
    setAuthForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveAuthorization = async () => {
    if (!visitor) return;

    const errors = {};
    if (
      authForm.social_worker_authorization === 'Não autorizado' &&
      !authForm.social_worker_motive.trim()
    ) {
      errors.social_worker_motive = 'Informe o motivo para recusar.';
    }

    if (Object.keys(errors).length > 0) {
      setAuthErrors(errors);
      return;
    }

    const payload = {
      social_worker_authorization: authForm.social_worker_authorization || 'Sem resposta',
      social_worker_motive:
        authForm.social_worker_authorization === 'Não autorizado'
          ? authForm.social_worker_motive
          : '',
    };

    setIsSavingAuth(true);
    try {
      await respondVisitorAuthorization(visitorId, payload);
      await Promise.all([loadVisitor(), loadAuthorizationHistory()]);
      closeAuthModal();
    } catch (error) {
      console.error('Erro ao atualizar autorização:', error);
    } finally {
      setIsSavingAuth(false);
    }
  };

  const handleOpenGeneralModal = () => {
    if (!canEditVisitorData) return;

    setEditData({
      ...visitor,
      color_or_ethnicity: resolveOptionId(colorOptions, visitor?.color_or_ethnicity),
      marital_status: resolveOptionId(maritalStatusOptions, visitor?.marital_status),
      gender: resolveOptionId(genderOptions, visitor?.gender),
      sexual_orientation: resolveOptionId(sexualOrientationOptions, visitor?.sexual_orientation),
      date_of_birth: visitor?.date_of_birth || '',
    });
    setCountrySearchQuery(visitor?.nationality || '');
    setCitySearchQuery(visitor?.naturalness || '');
    setShouldSearchCity(false);
    setFilteredCountries([]);
    setFilteredCities([]);
    setIsGeneralModalOpen(true);
  };

  const handleCancelEdit = () => {
    setEditData(visitor);
    setShouldSearchCity(false);
    setFilteredCountries([]);
    setFilteredCities([]);
    setIsGeneralModalOpen(false);
  };

  const handleCountrySearch = (query) => {
    const normalized = normalizeUpperNoAccent(query);
    setCountrySearchQuery(normalized);
    setEditData((prev) => ({ ...prev, nationality: normalized }));

    const trimmed = String(normalized || '').trim().toLowerCase();
    if (!trimmed) {
      setFilteredCountries([]);
      return;
    }

    const matches = (countryOptions || []).filter((item) =>
      String(item?.name || '').toLowerCase().includes(trimmed)
    );
    setFilteredCountries(matches);
  };

  const selectCountry = (countryName) => {
    setCountrySearchQuery(countryName);
    setEditData((prev) => ({ ...prev, nationality: countryName }));
    setFilteredCountries([]);
  };

  const handleCitySearch = (query) => {
    const normalized = normalizeUpperNoAccent(query);
    setShouldSearchCity(true);
    setCitySearchQuery(normalized);
    setEditData((prev) => ({ ...prev, naturalness: normalized }));
  };

  const selectCity = (cityName) => {
    setShouldSearchCity(false);
    setCitySearchQuery(cityName);
    setEditData((prev) => ({ ...prev, naturalness: cityName }));
    setFilteredCities([]);
  };

  useEffect(() => {
    const query = String(citySearchQuery || '').trim();

    if (!isGeneralModalOpen || !shouldSearchCity || query.length < 3) {
      setFilteredCities([]);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        const response = await listCity({ name: query });
        setFilteredCities(response?.results || []);
      } catch (error) {
        console.error('Erro ao buscar cidades no modal do visitante:', error);
        setFilteredCities([]);
      }
    }, 350);

    return () => clearTimeout(timer);
  }, [citySearchQuery, isGeneralModalOpen, listCity, shouldSearchCity]);

  useEffect(() => {
    const query = String(addressCityQuery || '').trim();
    if (!isAddressModalOpen || query.length < 3) {
      setAddressFilteredCities([]);
      return;
    }
    const timer = setTimeout(async () => {
      try {
        const response = await listCity({ name: query });
        setAddressFilteredCities(response?.results || []);
      } catch (error) {
        setAddressFilteredCities([]);
      }
    }, 350);
    return () => clearTimeout(timer);
  }, [addressCityQuery, isAddressModalOpen, listCity]);

  const handleSaveSection = async () => {
    if (!canEditVisitorData) return;
    if (!visitorId || !editData) return;
    const fields = generalFields;
    const payload = {};

    const normalizeComparableValue = (field, value) => {
      if (value === undefined) return undefined;
      if (value === null) return null;

      if (field === 'date_of_birth') {
        const raw = String(value || '').trim();
        if (!raw) return '';
        return raw.includes('T') ? raw.split('T')[0] : raw;
      }

      if (typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, 'id')) return value.id;
        if (Object.prototype.hasOwnProperty.call(value, 'name')) return value.name;
      }

      return value;
    };

    fields.forEach((field) => {
      if (!Object.prototype.hasOwnProperty.call(editData, field)) return;

      const nextValue = editData[field];
      const prevValue = visitor?.[field];

      // Não envia data vazia (endpoint reclama de datetime inválido)
      if (field === 'date_of_birth' && !String(nextValue || '').trim()) {
        return;
      }

      const normalizedNext = normalizeComparableValue(field, nextValue);
      const normalizedPrev = normalizeComparableValue(field, prevValue);

      // Envia apenas o que foi alterado
      if (String(normalizedNext ?? '') === String(normalizedPrev ?? '')) {
        return;
      }

      payload[field] = nextValue;
    });

    if (payload.date_of_birth) {
      payload.date_of_birth = String(payload.date_of_birth).split('T')[0];
    }

    if (Object.keys(payload).length === 0) {
      setIsGeneralModalOpen(false);
      return;
    }

    setIsSavingGeneral(true);
    try {
      await updateVisitor(visitorId, payload);
      await loadVisitor();
      setIsGeneralModalOpen(false);
    } catch (error) {
      console.error('Erro ao atualizar visitante:', error);
    } finally {
      setIsSavingGeneral(false);
    }
  };

  const handleDeleteFile = async (fileId) => {
    if (!window.confirm("Deseja realmente remover este documento?")) return;
    try {
      await updateVisitorFileActive(fileId, false);
      await loadVisitorFiles();
    } catch (error) {
      console.error("Erro ao remover documento:", error);
    }
  };

  const mainImageId = useMemo(() => {
    const images = visitorImages || [];
    const main = images.find(img => img.main || img.is_main) || images[0];
    return main?.id;
  }, [visitorImages]);

  const handleOpenRelationshipModal = async () => {
    if (!canEditRelationships) return;
    setPendingInternal(null);
    setPendingTypeRelation('');

    try {
      const data = await listVisitorRelationships(visitorId);
      const records = Array.isArray(data) ? data : [];
      setExistingVisitorRelationships(records);

      const enriched = (visitor?.internals || []).map((internal) => {
        const internalId = typeof internal === 'object' ? internal.id : internal;
        const rel = records.find((r) => {
          const rId = r?.internal?.id ?? r?.internal;
          return String(rId) === String(internalId);
        });
        return {
          id: internalId,
          name: internal.name || String(internalId),
          cpf: internal.cpf || internal.document || '',
          type_relationship: rel?.type_relationship?.id ?? rel?.type_relationship ?? '',
          relationship_record_id: rel?.id ?? null,
        };
      });
      setRelationshipInternals(enriched);
    } catch (error) {
      setExistingVisitorRelationships([]);
      setRelationshipInternals(mapVisitorInternals(visitor?.internals || []));
    }

    setSelectedTypeVisitorIds(
      Array.isArray(visitor?.type_visitor)
        ? visitor.type_visitor
          .map((type) => Number(type?.id))
          .filter((id) => !Number.isNaN(id))
        : []
    );
    setIsRelationshipModalOpen(true);
  };

  const handleAddRelationshipInternal = (internal) => {
    if (!internal || !internal.id) return;
    if (relationshipInternals.some((item) => item.id === internal.id)) {
      toast.warning('Este interno já está vinculado.');
      return;
    }
    setPendingInternal(internal);
    setPendingTypeRelation('');
  };

  const handleConfirmPendingInternal = () => {
    if (!pendingInternal) return;
    if (!pendingTypeRelation) {
      toast.warning('Selecione o tipo de parentesco.');
      return;
    }
    setRelationshipInternals((prev) => [
      ...prev,
      {
        id: pendingInternal.id,
        name: pendingInternal.name,
        cpf: pendingInternal.cpf || pendingInternal.document || '',
        type_relationship: Number(pendingTypeRelation),
        relationship_record_id: null,
      },
    ]);
    setPendingInternal(null);
    setPendingTypeRelation('');
  };

  const handleCancelPendingInternal = () => {
    setPendingInternal(null);
    setPendingTypeRelation('');
  };

  const handleChangeRelationshipType = (internalId, typeId) => {
    setRelationshipInternals((prev) =>
      prev.map((item) =>
        item.id === internalId ? { ...item, type_relationship: Number(typeId) || '' } : item
      )
    );
  };

  const handleRemoveRelationshipInternal = (internalId) => {
    setRelationshipInternals((prev) => prev.filter((item) => item.id !== internalId));
  };

  const handleToggleTypeVisitor = (typeId) => {
    const numericTypeId = Number(typeId);
    if (Number.isNaN(numericTypeId)) return;

    setSelectedTypeVisitorIds((prev) => (
      prev.includes(numericTypeId)
        ? prev.filter((id) => id !== numericTypeId)
        : [...prev, numericTypeId]
    ));
  };

  const handleCancelRelationships = () => {
    setPendingInternal(null);
    setPendingTypeRelation('');
    setRelationshipInternals(mapVisitorInternals(visitor?.internals || []));
    setSelectedTypeVisitorIds(
      Array.isArray(visitor?.type_visitor)
        ? visitor.type_visitor
          .map((type) => Number(type?.id))
          .filter((id) => !Number.isNaN(id))
        : []
    );
    setIsRelationshipModalOpen(false);
  };

  const handleSaveRelationships = async () => {
    if (!canEditRelationships) return;
    if (!visitorId) return;
    setIsSavingRelationships(true);
    try {
      const existingById = {};
      existingVisitorRelationships.forEach((rel) => {
        const internalId = String(rel?.internal?.id ?? rel?.internal ?? '');
        if (internalId) existingById[internalId] = rel;
      });

      // Cria novos ou atualiza tipo se mudou
      for (const rel of relationshipInternals) {
        const internalId = String(rel.id);
        const existing = existingById[internalId];

        if (!existing) {
          if (rel.type_relationship) {
            await createVisitorRelationship({
              date: new Date().toISOString(),
              visitor: visitorId,
              internal: rel.id,
              type_relationship: Number(rel.type_relationship),
            });
          }
        } else {
          const existingTypeId = existing?.type_relationship?.id ?? existing?.type_relationship;
          if (String(existingTypeId) !== String(rel.type_relationship) && rel.type_relationship) {
            await updateVisitorRelationship(existing.id, {
              type_relationship: Number(rel.type_relationship),
            });
          }
        }
      }

      const hasIntimaType = typeVisitorOptions.some((opt) => {
        const name = (opt?.name || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();
        return (name === 'INTIMA' || name === 'INTIMO') && selectedTypeVisitorIds.includes(Number(opt.id));
      });

      await updateVisitor(visitorId, {
        internals: relationshipInternals.map((r) => r.id),
        type_visitor: selectedTypeVisitorIds,
        intimate: hasIntimaType,
      });

      await loadVisitor();
      await loadVisitorRelationships();
      setIsRelationshipModalOpen(false);
    } catch (error) {
      console.error('Erro ao salvar relacionamentos:', error);
      toast.error('Erro ao salvar relacionamentos.');
    } finally {
      setIsSavingRelationships(false);
    }
  };

  const buildInitialAddressForm = () => ({
    neighborhood: '',
    public_place: '',
    complement: '',
    cep: '',
    main: false,
    city: '',
  });

  const handleOpenAddAddress = () => {
    if (!canEditVisitorData) return;
    setEditingAddressId(null);
    setAddressFormData(buildInitialAddressForm());
    setAddressCityQuery('');
    setAddressCityDisplay('');
    setAddressFilteredCities([]);
    setIsAddressModalOpen(true);
  };

  const handleOpenEditAddress = (address) => {
    if (!canEditVisitorData) return;
    setEditingAddressId(address.id);
    setAddressFormData({
      neighborhood: address.neighborhood || '',
      public_place: address.public_place || '',
      complement: address.complement || '',
      cep: address.cep || '',
      main: !!address.main,
      city: address.city || '',
    });
    setAddressCityQuery('');
    setAddressCityDisplay(address.city_name || String(address.city || ''));
    setAddressFilteredCities([]);
    setIsAddressModalOpen(true);
  };

  const handleCloseAddressModal = () => {
    setIsAddressModalOpen(false);
    setEditingAddressId(null);
    setAddressFormData(buildInitialAddressForm());
    setAddressCityQuery('');
    setAddressCityDisplay('');
    setAddressFilteredCities([]);
  };

  const handleAddressFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAddressFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleAddressCitySearch = (query) => {
    setAddressCityDisplay(query);
    setAddressCityQuery(query);
    if (!query) {
      setAddressFormData((prev) => ({ ...prev, city: '' }));
    }
  };

  const selectAddressCity = (city) => {
    setAddressCityDisplay(city.name);
    setAddressCityQuery('');
    setAddressFilteredCities([]);
    setAddressFormData((prev) => ({ ...prev, city: city.id }));
  };

  const handleSaveAddress = async () => {
    if (!canEditVisitorData) return;
    if (!addressFormData.city) {
      toast.warning('Selecione uma cidade.');
      return;
    }
    setIsSavingAddress(true);
    try {
      const payload = {
        neighborhood: addressFormData.neighborhood,
        public_place: addressFormData.public_place,
        complement: addressFormData.complement,
        cep: addressFormData.cep,
        main: addressFormData.main,
        city: Number(addressFormData.city),
        person: visitorId,
      };
      if (editingAddressId) {
        await updateVisitorAddress(editingAddressId, payload);
      } else {
        await createVisitorAddress(payload);
      }
      toast.success(editingAddressId ? 'Endereço atualizado.' : 'Endereço adicionado.');
      handleCloseAddressModal();
      await loadVisitorAddresses();
    } catch (error) {
      const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;
      toast.error(typeof apiMessage === 'string' && apiMessage ? apiMessage : 'Erro ao salvar endereço.');
    } finally {
      setIsSavingAddress(false);
    }
  };

  const handleOpenAddPhone = () => {
    if (!canEditVisitorData) return;
    setEditingPhoneId(null);
    setPhoneFormData({ name: '', title: '', number: '' });
    setIsPhoneModalOpen(true);
  };

  const handleOpenEditPhone = (phone) => {
    if (!canEditVisitorData) return;
    setEditingPhoneId(phone.id);
    setPhoneFormData({
      name: phone.name || '',
      title: phone.title || '',
      number: phone.number || '',
    });
    setIsPhoneModalOpen(true);
  };

  const handleClosePhoneModal = () => {
    setIsPhoneModalOpen(false);
    setEditingPhoneId(null);
    setPhoneFormData({ name: '', title: '', number: '' });
  };

  const handlePhoneFormChange = (e) => {
    const { name, value } = e.target;
    setPhoneFormData((prev) => ({
      ...prev,
      [name]: name === 'name' ? value.toUpperCase() : value,
    }));
  };

  const handleSavePhone = async () => {
    if (!canEditVisitorData) return;
    if (!phoneFormData.name || !phoneFormData.title || !phoneFormData.number) {
      toast.warning('Preencha todos os campos do telefone.');
      return;
    }
    setIsSavingPhone(true);
    try {
      const payload = {
        name: phoneFormData.name.toUpperCase(),
        title: phoneFormData.title,
        number: phoneFormData.number,
        person: visitorId,
      };
      if (editingPhoneId) {
        await updateVisitorPhone(editingPhoneId, payload);
      } else {
        await createVisitorPhone(payload);
      }
      handleClosePhoneModal();
      await loadVisitorPhones();
    } catch (error) {
      const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;
      toast.error(typeof apiMessage === 'string' && apiMessage ? apiMessage : 'Erro ao salvar telefone.');
    } finally {
      setIsSavingPhone(false);
    }
  };

  const handleOpenPhotoModal = () => {
    if (!canEditVisitorData) return;
    setPhotoFile(null);
    setPhotoPreviewUrl(null);
    setIsPhotoModalOpen(true);
  };

  const handleClosePhotoModal = () => {
    setPhotoFile(null);
    setPhotoPreviewUrl(null);
    setIsPhotoModalOpen(false);
  };

  const handlePhotoFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setPhotoFile(file);
    if (file) {
      setPhotoPreviewUrl(URL.createObjectURL(file));
    } else {
      setPhotoPreviewUrl(null);
    }
  };

  const handleSavePhoto = async () => {
    if (!canEditVisitorData || !visitorId) return;
    if (!photoFile) {
      toast.warning('Selecione uma imagem para enviar.');
      return;
    }
    const fileName = String(photoFile.name || '').toLowerCase();
    const hasAllowedExtension = ['.jpg', '.jpeg', '.png'].some((ext) => fileName.endsWith(ext));
    if (!hasAllowedExtension) {
      toast.warning('Formato inválido. Envie JPG, JPEG ou PNG.');
      return;
    }
    setIsSavingPhoto(true);
    try {
      const formData = new FormData();
      formData.append('picture', photoFile);
      formData.append('visitor', String(visitorId));
      formData.append('type_image', '2'); // 2 = Foto 3x4
      if (mainImageId) {
        await updateVisitorImage(mainImageId, formData);
      } else {
        await createVisitorImage(formData);
      }
      await loadVisitorImages();
      handleClosePhotoModal();
    } catch (error) {
      console.error('Erro ao salvar foto do visitante:', error);
    } finally {
      setIsSavingPhoto(false);
    }
  };

  const handleOpenDocumentModal = () => {
    if (!canEditVisitorData) return;
    setDocumentForm({
      type_file: '',
      file: null,
    });
    setIsDocumentModalOpen(true);
  };

  const handleCloseDocumentModal = () => {
    setDocumentForm({
      type_file: '',
      file: null,
    });
    setIsDocumentModalOpen(false);
  };

  const handleDocumentFormChange = (event) => {
    const { name, value, files } = event.target;

    if (name === 'file') {
      setDocumentForm((prev) => ({
        ...prev,
        file: files?.[0] || null,
      }));
      return;
    }

    setDocumentForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveDocument = async () => {
    if (!canEditVisitorData) return;
    if (!visitorId) return;

    const typeFileId = Number(documentForm.type_file);
    if (!typeFileId || Number.isNaN(typeFileId)) {
      toast.warning('Selecione o tipo do documento.');
      return;
    }

    const selectedFile = documentForm.file;
    if (!selectedFile) {
      toast.warning('Selecione um arquivo para enviar.');
      return;
    }

    const fileName = String(selectedFile.name || '').toLowerCase();
    const hasAllowedExtension = ['.pdf', '.jpg', '.jpeg'].some((ext) => fileName.endsWith(ext));
    if (!hasAllowedExtension) {
      toast.warning('Formato inválido. Envie PDF, JPG ou JPEG.');
      return;
    }

    setIsSavingDocument(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('type_file', String(typeFileId));
      formData.append('visitor', String(visitorId));

      await createVisitorFile(formData);
      await loadVisitorFiles();
      handleCloseDocumentModal();
    } catch (error) {
      console.error('Erro ao salvar documento do visitante:', error);
    } finally {
      setIsSavingDocument(false);
    }
  };

  const statusBadge = useMemo(() => {
    const status = getVisitorDisplayStatus(visitor);
    return {
      ...status,
      className: status.className ? `visitor-status ${status.className}` : '',
    };
  }, [visitor]);


  const renderInfoRow = (label, value, key) => (
    <div className="visitor-info-row visitor-info-tile" key={key || label}>
      <span>{label}</span>
      <p>{value || '-'}</p>
    </div>
  );

  const renderAccessTag = (label, enabled) => (
    <span className={`visitor-access-tag ${enabled ? 'enabled' : 'disabled'}`} key={label}>
      {label}: {enabled ? 'AUTORIZADO' : 'NAO AUTORIZADO'}
    </span>
  );

  const renderAuthorizationStatusTag = (label, statusValue) => {
    const normalized = normalizeVisitorAuthStatus(statusValue);
    let variant = 'pending';
    let text = statusValue || 'Sem resposta';

    if (normalized === 'autorizado') variant = 'enabled';
    if (normalized === 'nao autorizado') variant = 'denied';
    if (normalized === 'sem resposta') variant = 'pending';

    return (
      <div className="visitor-info-row visitor-info-tile" key={`auth-${label}`}>
        <span>{label}</span>
        <p>
          <span className={`visitor-access-tag ${variant}`}>{text}</span>
        </p>
      </div>
    );
  };

  const resolveTypeRelationName = (typeId) => {
    if (!typeId && typeId !== 0) return null;
    const option = typeRelationOptions.find((opt) => String(opt.id) === String(typeId));
    return option?.name || null;
  };

  const renderInternalList = (items, emptyText = 'Nenhum registro') => {
    if (!items || items.length === 0) {
      return <li key="empty">{emptyText}</li>;
    }

    return items.map((item, index) => {
      const internalId = item?.id;
      const relRecord = internalId ? visitorRelationshipMap[String(internalId)] : null;
      const relTypeId = relRecord?.type_relationship?.id ?? relRecord?.type_relationship;
      const relTypeName = resolveTypeRelationName(relTypeId);

      return (
        <li key={internalId || `${item?.name}-${index}`} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {internalId ? (
            <Link
              className="visitor-internal-link"
              to={isExternalProfile ? `/internos/detalhes-externo/${internalId}` : `/internos/${internalId}`}
            >
              {item?.name || '-'}
            </Link>
          ) : (
            item?.name || '-'
          )}
          {relTypeName && (
            <span className="visitor-access-tag enabled" style={{ fontSize: '11px' }}>
              {relTypeName}
            </span>
          )}
        </li>
      );
    });
  };

  const typeVisitorNames = visitor?.type_visitor
    ?.map((type) => type.name)
    .join(', ');

  const hasIntimateTypeVisitor = useMemo(() => {
    const typeVisitors = visitor?.type_visitor;
    if (!Array.isArray(typeVisitors)) return false;

    return typeVisitors.some((typeVisitor) => {
      const label =
        typeVisitor?.name ||
        typeVisitor?.type ||
        (typeof typeVisitor === 'string' ? typeVisitor : '');
      return normalizePermissionText(label).includes('INTIMA');
    });
  }, [visitor?.type_visitor]);

  const socialWorkerName = visitor?.social_worker?.name || '-';

  const renderContent = () => {
    if (isLoading) {
      return <div className="visitor-details-card">Carregando visitante...</div>;
    }

    if (!visitor) {
      return (
        <div className="visitor-details-card">
          Não foi possível localizar os dados do visitante.
        </div>
      );
    }

    return (
      <>
        <section className="visitor-details-card">
          <header>
            <div className="visitor-hero-wrapper">
              <div
                className={`visitor-hero-photo${canEditVisitorData ? ' visitor-hero-photo--clickable' : ''}`}
                onClick={canEditVisitorData ? handleOpenPhotoModal : undefined}
                title={canEditVisitorData ? (visitorMainPhoto ? 'Clique para trocar a foto' : 'Clique para adicionar foto') : undefined}
              >
                {visitorMainPhoto ? (
                  <BinaryImage
                    resource={visitorMainPhoto.resource}
                    id={visitorMainPhoto.id}
                    field={visitorMainPhoto.field}
                    alt={`Foto de ${visitor.name}`}
                  />
                ) : canEditVisitorData ? (
                  <span className="visitor-hero-photo-empty">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="16 16 12 12 8 16" />
                      <line x1="12" y1="12" x2="12" y2="21" />
                      <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                    </svg>
                    <small>Adicionar foto</small>
                  </span>
                ) : (
                  <span className="visitor-hero-photo-empty">Sem foto</span>
                )}
              </div>
              <div className="visitor-hero-meta">
                <h3>{visitor.name}</h3>
                <div className="visitor-hero-tags">
                  {statusBadge.className && (
                    <span className={statusBadge.className}>{statusBadge.label}</span>
                  )}
                  {renderAccessTag('Visita íntima', hasIntimateTypeVisitor)}
                  {renderAccessTag('Visita virtual', !!visitor.virtual)}
                </div>
              </div>
            </div>
            <div className="visitor-section-actions">
              {canEditVisitorData && (
                <button
                  type="button"
                  className="btn-visitor-secondary"
                  onClick={handleOpenGeneralModal}
                >
                  Editar dados
                </button>
              )}
            </div>
          </header>
          <SectionTitle icon={faIdCard}>Dados pessoais</SectionTitle>
          <div className="visitor-details-grid">
            {renderInfoRow('Nome social', visitor.social_name)}
            {renderInfoRow('RG', visitor.rg)}
            {renderInfoRow('CPF', formatCpfDisplay(visitor.cpf))}
            {renderInfoRow('Email', visitor.email)}
            {renderInfoRow(
              'Data de nascimento',
              visitor.date_of_birth ? new Date(visitor.date_of_birth).toLocaleDateString('pt-BR') : '-'
            )}
            {renderInfoRow('Naturalidade', visitor.naturalness)}
            {renderInfoRow('Nacionalidade', visitor.nationality)}
            {renderInfoRow('Cor/Etnia', resolveOptionLabel(colorOptions, visitor.color_or_ethnicity))}
            {renderInfoRow('Estado civil', resolveOptionLabel(maritalStatusOptions, visitor.marital_status))}
            {renderInfoRow('Sexo', resolveOptionLabel(genderOptions, visitor.gender))}
            {renderInfoRow('Orientação sexual', resolveOptionLabel(sexualOrientationOptions, visitor.sexual_orientation))}
            {renderInfoRow('Registro', visitor.registration)}
            {renderInfoRow('OAB', visitor.oab)}
            {renderInfoRow('UF da OAB', visitor.uf_oab)}
            {renderInfoRow('Tipo de inscrição OAB', getTypeOabLabel(visitor.type_oab))}
          </div>
        </section>

        <section className="visitor-details-card">
          {isExternalProfile ? (
            // Perfil externo (Polícia) não vê a autorização do Serviço Social, só o histórico de bloqueios.
            <header>
              <div>
                <SectionTitle icon={faShieldHalved}>Histórico de bloqueios</SectionTitle>
              </div>
            </header>
          ) : (
            <>
              <header>
                <div>
                  <SectionTitle icon={faShieldHalved}>Autorizações</SectionTitle>
                  <span>Serviço Social autoriza a visita</span>
                </div>
                <div className="visitor-section-actions">
                  {canShowAuthorizationAction && (
                    <button
                      type="button"
                      className="btn-visitor-secondary"
                      onClick={handleOpenAuthModal}
                    >
                      Autorização
                    </button>
                  )}
                </div>
              </header>
              <div className="visitor-authorization-grid">
                <div className="authorization-column">
                  <h4>Serviço Social</h4>
                  {renderAuthorizationStatusTag('Status', visitor.social_worker_authorization)}
                  {renderInfoRow('Motivo da recusa', visitor.social_worker_motive, 'social-motive')}
                  {renderInfoRow('Responsável', socialWorkerName, 'social-resp')}
                </div>
              </div>
            </>
          )}
          <div className="visitor-auth-history">
            {!isExternalProfile && <h4>Histórico de bloqueios</h4>}
            {isLoadingAuthorizationHistory ? (
              <p className="visitor-docs-empty">Carregando histórico...</p>
            ) : authorizationHistory.length === 0 ? (
              <p className="visitor-docs-empty">Nenhum dado a ser mostrado por aqui</p>
            ) : (
              <div className="visitor-auth-history-list">
                {authorizationHistory.map((item, index) => (
                  <article className="visitor-auth-history-item" key={item?.id || `auth-history-${index}`}>
                    <div className="visitor-auth-history-head">
                      <strong>{item?.user_name || 'Usuário não informado'}</strong>
                      <span>{formatDateTimePtBr(item?.date)}</span>
                    </div>

                    <div className="visitor-auth-history-grid">
                      <div>
                        <small>Motivo</small>
                        <p>{item?.motive || '-'}</p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>

        <section className="visitor-details-card">
          <header>
            <SectionTitle icon={faUserGroup}>Relacionamentos</SectionTitle>
            <div className="visitor-section-actions">
              {canEditRelationships && (
                <button
                  type="button"
                  className="btn-visitor-secondary"
                  onClick={handleOpenRelationshipModal}
                >
                  Editar
                </button>
              )}
            </div>
          </header>
          <div className="visitor-details-relations">
            <div>
              <strong>Tipo(s) de visitante</strong>
              <p>{typeVisitorNames || '-'}</p>
            </div>
            <div>
              <strong>Internos associados</strong>
              <ul>{renderInternalList(visitor.internals, 'Nenhum interno vinculado')}</ul>
            </div>
          </div>
        </section>

        <section className="visitor-details-card">
          <header>
            <SectionTitle icon={faLocationDot}>Endereços</SectionTitle>
            <div className="visitor-section-actions">
              {canEditVisitorData && (
                <button
                  type="button"
                  className="btn-visitor-secondary"
                  onClick={handleOpenAddAddress}
                >
                  Adicionar endereço
                </button>
              )}
            </div>
          </header>
          {isLoadingAddresses ? (
            <p className="visitor-docs-empty">Carregando endereços...</p>
          ) : visitorAddresses.length === 0 ? (
            <p className="visitor-docs-empty">Nenhum endereço cadastrado.</p>
          ) : (
            <table className="movements-table">
              <thead>
                <tr>
                  <th>Logradouro</th>
                  <th>Bairro</th>
                  <th>Complemento</th>
                  <th>CEP</th>
                  <th>Principal</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {visitorAddresses.map((address) => (
                  <tr key={address.id}>
                    <td>{address.public_place || '-'}</td>
                    <td>{address.neighborhood || '-'}</td>
                    <td>{address.complement || '-'}</td>
                    <td>{address.cep || '-'}</td>
                    <td>{address.main ? 'Sim' : 'Não'}</td>
                    <td className="td-table-icon">
                      <button
                        type="button"
                        className="movement-view-button"
                        title="Ver detalhes"
                        onClick={() => { setViewingAddress(address); setIsAddressViewModalOpen(true); }}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                      {canEditVisitorData && (
                        <button
                          type="button"
                          className="movement-view-button"
                          title="Editar endereço"
                          onClick={() => handleOpenEditAddress(address)}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>

        <section className="visitor-details-card">
          <header>
            <SectionTitle icon={faPhone}>Contatos</SectionTitle>
            <div className="visitor-section-actions">
              {canEditVisitorData && (
                <button
                  type="button"
                  className="btn-visitor-secondary"
                  onClick={handleOpenAddPhone}
                >
                  Adicionar telefone
                </button>
              )}
            </div>
          </header>
          {isLoadingPhones ? (
            <p className="visitor-docs-empty">Carregando telefones...</p>
          ) : visitorPhones.length === 0 ? (
            <p className="visitor-docs-empty">Nenhum telefone cadastrado.</p>
          ) : (
            <table className="movements-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Título</th>
                  <th>Número</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {visitorPhones.map((phone) => (
                  <tr key={phone.id}>
                    <td>{phone.name || '-'}</td>
                    <td>{phone.title || '-'}</td>
                    <td>{phone.number || '-'}</td>
                    <td className="td-table-icon">
                      {canEditVisitorData && (
                        <button
                          type="button"
                          className="movement-view-button"
                          title="Editar telefone"
                          onClick={() => handleOpenEditPhone(phone)}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>

        <section className="visitor-details-card">
          <header>
            <SectionTitle icon={faFileLines}>Documentos enviados</SectionTitle>
            <div className="visitor-section-actions">
              {canEditVisitorData && (
                <button
                  type="button"
                  className="btn-visitor-secondary"
                  onClick={handleOpenDocumentModal}
                >
                  Adicionar documento
                </button>
              )}
            </div>
          </header>

          {isLoadingFiles ? (
            <p className="visitor-docs-empty">Carregando documentos...</p>
          ) : visitorFiles.length === 0 ? (
            <p className="visitor-docs-empty">Nenhum documento encontrado para este visitante.</p>
          ) : (
            <div className="visitor-docs-list">
              {visitorFiles.map((fileItem, index) => {
                return (
                  <article className="visitor-docs-item" key={fileItem?.id || `file-${index}`}>
                    <div className="visitor-docs-meta">
                      <strong>{resolveVisitorFileName(fileItem, index)}</strong>
                      <span>Enviado em: {formatDateTimePtBr(fileItem?.date || fileItem?.created_at || fileItem?.updated_at)}</span>
                    </div>
                    {hasBinaryField(fileItem, 'file') ? (
                      <BinaryFileLink
                        className="app-drawer__file-link"
                        resource={BINARY_RESOURCES.visitorFile}
                        id={fileItem.id}
                        field="file"
                      >
                        Visualizar documento
                      </BinaryFileLink>
                    ) : (
                      <span className="visitor-docs-empty">Arquivo indisponivel.</span>
                    )}
                    {canEditVisitorData && (
                      <button
                        type="button"
                        className="btn-delete-icon-list"
                        onClick={() => handleDeleteFile(fileItem.id)}
                        title="Remover documento"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )}
                  </article>
                );
              })}
            </div>
          )}
        </section>
      </>
    );
  };

  if (!visitorId) {
    return (
      <div>
        <Sidebar />
        <Header />
        <div className="container visitor-details-page">
          <Titulo
            children={<h2>Detalhes do visitante</h2>}
            children2={
              <div className="visitor-action-buttons">
                <button className="btn-visitor-back" onClick={() => navigate(-1)}>
                  Voltar
                </button>
              </div>
            }
          />
          <div className="visitor-details-card">
            Nenhum visitante selecionado. Volte e escolha um visitante na lista.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container visitor-details-page">
        <Titulo
          children={<h2>Detalhes do visitante</h2>}
          children2={
            <div className="visitor-action-buttons">
              <button className="btn-visitor-back" onClick={() => navigate(-1)}>
                Voltar
              </button>
            </div>
          }
        />

        {renderContent()}

        {canEditVisitorData && (
          <Modal
            isOpen={isGeneralModalOpen}
            closeModal={handleCancelEdit}
          >
            <h3>Editar dados pessoais</h3>
            <div className="div-form-container">
              <div className="form-group">
                <label>Nome completo</label>
                <input
                  type='text'
                  name="name"
                  value={editData?.name || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Nome social</label>
                <input
                  type='text'
                  name="social_name"
                  value={editData?.social_name || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>CPF</label>
                <FormattedInput
                  type="cpf"
                  name="cpf"
                  value={editData?.cpf || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>RG</label>
                <input
                  type='text'
                  name="rg"
                  value={editData?.rg || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Data de nascimento</label>
                <input
                  type="date"
                  name="date_of_birth"
                  value={formatDateForInput(editData?.date_of_birth)}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={editData?.email || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Naturalidade</label>
                <div className="visitor-autocomplete">
                  <input
                    type='text'
                    name="naturalness"
                    value={editData?.naturalness || ''}
                    onChange={(e) => handleCitySearch(e.target.value)}
                  />
                  {filteredCities.length > 0 && (
                    <ul className="visitor-autocomplete-list">
                      {filteredCities.map((city) => (
                        <li key={city.id} onClick={() => selectCity(city.name)}>
                          {city.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>Nacionalidade</label>
                <div className="visitor-autocomplete">
                  <input
                    type='text'
                    name="nationality"
                    value={editData?.nationality || ''}
                    onChange={(e) => handleCountrySearch(e.target.value)}
                  />
                  {filteredCountries.length > 0 && (
                    <ul className="visitor-autocomplete-list">
                      {filteredCountries.map((country) => (
                        <li key={country.id} onClick={() => selectCountry(country.name)}>
                          {country.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>Cor/Etnia</label>
                <select
                  name="color_or_ethnicity"
                  value={editData?.color_or_ethnicity ?? ''}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione</option>
                  {colorOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Estado civil</label>
                <select
                  name="marital_status"
                  value={editData?.marital_status ?? ''}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione</option>
                  {maritalStatusOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Sexo</label>
                <select
                  name="gender"
                  value={editData?.gender ?? ''}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione</option>
                  {genderOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Orientação sexual</label>
                <select
                  name="sexual_orientation"
                  value={editData?.sexual_orientation ?? ''}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione</option>
                  {sexualOrientationOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Registro</label>
                <input
                  type='text'
                  name="registration"
                  value={editData?.registration || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>OAB</label>
                <input
                  type='text'
                  name="oab"
                  value={editData?.oab || ''}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>UF da OAB</label>
                <input
                  type='text'
                  name="uf_oab"
                  value={editData?.uf_oab || ''}
                  onChange={handleInputChange}
                  maxLength={2}
                  placeholder="Ex: PI"
                />
              </div>
              <div className="form-group">
                <label>Tipo de inscrição OAB</label>
                <select
                  name="type_oab"
                  value={editData?.type_oab || ''}
                  onChange={handleInputChange}
                >
                  <option value="">Selecione</option>
                  {TYPE_OAB_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group visitor-switch-group">
                <label>Autorização para visita virtual</label>
                <div className="visitor-switch-row">
                  <span className={`visitor-switch-label ${!editData?.virtual ? 'active' : ''}`}>Não</span>
                  <label className="visitor-switch">
                    <input
                      type="checkbox"
                      name="virtual"
                      checked={!!editData?.virtual}
                      onChange={handleInputChange}
                    />
                    <span className="visitor-switch-slider" />
                  </label>
                  <span className={`visitor-switch-label ${!!editData?.virtual ? 'active' : ''}`}>Sim</span>
                </div>
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSaveSection}
                disabled={isSavingGeneral}
              >
                {isSavingGeneral ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </Modal>
        )}

        {canEditRelationships && (
          <Modal
            isOpen={isRelationshipModalOpen}
            closeModal={handleCancelRelationships}
          >
            <div className="relationship-types-section">
              <h4>Tipo(s) de visitante</h4>
              {typeVisitorOptions.length > 0 ? (
                <div className="relationship-types-grid">
                  {typeVisitorOptions.map((type) => {
                    const typeId = Number(type?.id);
                    const isChecked = selectedTypeVisitorIds.includes(typeId);
                    return (
                      <label key={type.id} className="relationship-type-option">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => handleToggleTypeVisitor(type.id)}
                        />
                        <span>{type.name}</span>
                      </label>
                    );
                  })}
                </div>
              ) : (
                <p className="relationship-empty">Nenhum tipo de visitante disponível.</p>
              )}
            </div>
            <h3>Internos relacionados</h3>
            <SearchInternal
              onSelect={(internal) => handleAddRelationshipInternal(internal)}
            />

            {pendingInternal && (
              <div className="relationship-pending-card">
                <div className="relationship-pending-info">
                  <strong>{pendingInternal.name}</strong>
                  {pendingInternal.cpf && <span>{pendingInternal.cpf}</span>}
                </div>
                <div className="relationship-pending-form">
                  <select
                    value={pendingTypeRelation}
                    onChange={(e) => setPendingTypeRelation(e.target.value)}
                    className="relationship-pending-select"
                  >
                    <option value="">Selecione o parentesco</option>
                    {typeRelationOptions.map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.name}</option>
                    ))}
                  </select>
                  <div className="relationship-pending-actions">
                    <button
                      type="button"
                      className="btn-visitor-secondary"
                      onClick={handleConfirmPendingInternal}
                    >
                      Confirmar
                    </button>
                    <button
                      type="button"
                      className="btn-visitor-back"
                      onClick={handleCancelPendingInternal}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="relationship-results">
              <h4>Vinculados</h4>
              {relationshipInternals.length > 0 ? (
                <table>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Parentesco</th>
                      <th>Remover</th>
                    </tr>
                  </thead>
                  <tbody>
                    {relationshipInternals.map((internal, index) => (
                      <tr key={internal.id || `${internal.name}-${index}`}>
                        <td>{internal.name}</td>
                        <td>
                          <select
                            value={internal.type_relationship || ''}
                            onChange={(e) => handleChangeRelationshipType(internal.id, e.target.value)}
                            className="relationship-type-select"
                          >
                            <option value="">Sem parentesco</option>
                            {typeRelationOptions.map((opt) => (
                              <option key={opt.id} value={opt.id}>{opt.name}</option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <button
                            style={{
                              background: 'none',
                              color: 'var(--Vermelho)',
                              fontSize: '20px'
                            }}
                            type="button"
                            className="btn-visitor-back"
                            onClick={() => handleRemoveRelationshipInternal(internal.id)}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="relationship-empty">Nenhum interno vinculado.</p>
              )}
            </div>

            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSaveRelationships}
                disabled={isSavingRelationships}
              >
                {isSavingRelationships ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </Modal>
        )}

        {canEditVisitorData && (
          <Modal
            isOpen={isPhotoModalOpen}
            closeModal={handleClosePhotoModal}
          >
            <div className="photo-modal-header">
              <span className="photo-modal-label">Foto do visitante</span>
              <p className="photo-modal-hint">JPG, JPEG ou PNG</p>
            </div>

            <label className="photo-upload-zone" htmlFor="visitor-photo-input">
              {photoPreviewUrl ? (
                <>
                  <img className="photo-upload-preview" src={photoPreviewUrl} alt="Prévia" />
                  <span className="photo-upload-overlay">Trocar foto</span>
                </>
              ) : (
                <span className="photo-upload-placeholder">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 16 12 12 8 16" />
                    <line x1="12" y1="12" x2="12" y2="21" />
                    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                  </svg>
                  <span className="photo-upload-placeholder-text">
                    Clique para adicionar foto
                    <small>JPG, JPEG ou PNG</small>
                  </span>
                </span>
              )}
              <input
                id="visitor-photo-input"
                type="file"
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                onChange={handlePhotoFileChange}
                style={{ display: 'none' }}
              />
            </label>

            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSavePhoto}
                disabled={isSavingPhoto || !photoFile}
              >
                {isSavingPhoto ? 'Salvando...' : mainImageId ? 'Atualizar foto' : 'Salvar foto'}
              </button>
            </div>
          </Modal>
        )}

        {canEditVisitorData && (
          <Modal
            isOpen={isDocumentModalOpen}
            closeModal={handleCloseDocumentModal}
          >
            <h3>Adicionar documento</h3>
            <div className="div-form-container visitor-doc-upload-form">
              <div className="form-group">
                <label>Tipo de documento</label>
                <select
                  name="type_file"
                  value={documentForm.type_file}
                  onChange={handleDocumentFormChange}
                >
                  <option value="">Selecione</option>
                  {typeFileOptions.map((typeFile) => (
                    <option key={typeFile.id} value={typeFile.id}>
                      {typeFile.type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Arquivo (PDF, JPG ou JPEG)</label>
                <input
                  type="file"
                  name="file"
                  accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                  onChange={handleDocumentFormChange}
                />
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSaveDocument}
                disabled={isSavingDocument}
              >
                {isSavingDocument ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </Modal>
        )}

        <Modal
          isOpen={isAddressViewModalOpen}
          closeModal={() => { setIsAddressViewModalOpen(false); setViewingAddress(null); }}
          title="Detalhes do endereço"
        >
          {viewingAddress && (
            <div className="movement-details-modal">
              <div className="movement-details-grid">
                <div className="movement-details-card">
                  <span>Logradouro</span>
                  <strong>{viewingAddress.public_place || '-'}</strong>
                </div>
                <div className="movement-details-card">
                  <span>Bairro</span>
                  <strong>{viewingAddress.neighborhood || '-'}</strong>
                </div>
                <div className="movement-details-card">
                  <span>Complemento</span>
                  <strong>{viewingAddress.complement || '-'}</strong>
                </div>
                <div className="movement-details-card">
                  <span>CEP</span>
                  <strong>{viewingAddress.cep || '-'}</strong>
                </div>
                <div className="movement-details-card">
                  <span>Principal</span>
                  <strong>{viewingAddress.main ? 'Sim' : 'Não'}</strong>
                </div>
              </div>
            </div>
          )}
        </Modal>

        {canEditVisitorData && (
          <Modal
            isOpen={isAddressModalOpen}
            closeModal={handleCloseAddressModal}
          >
            <h3>{editingAddressId ? 'Editar endereço' : 'Adicionar endereço'}</h3>
            <div className="div-form-container">
              <div className="form-group">
                <label>Logradouro</label>
                <input
                  type="text"
                  name="public_place"
                  value={addressFormData.public_place}
                  onChange={handleAddressFormChange}
                />
              </div>
              <div className="form-group">
                <label>Bairro</label>
                <input
                  type="text"
                  name="neighborhood"
                  value={addressFormData.neighborhood}
                  onChange={handleAddressFormChange}
                />
              </div>
              <div className="form-group">
                <label>Complemento</label>
                <input
                  type="text"
                  name="complement"
                  value={addressFormData.complement}
                  onChange={handleAddressFormChange}
                />
              </div>
              <div className="form-group">
                <label>CEP</label>
                <FormattedInput
                  type="cep"
                  name="cep"
                  value={addressFormData.cep}
                  onChange={handleAddressFormChange}
                />
              </div>
              <div className="form-group">
                <label>Cidade</label>
                <div className="visitor-autocomplete">
                  <input
                    type="text"
                    value={addressCityDisplay}
                    onChange={(e) => handleAddressCitySearch(e.target.value)}
                    placeholder="Digite para buscar..."
                  />
                  {addressFilteredCities.length > 0 && (
                    <ul className="visitor-autocomplete-list">
                      {addressFilteredCities.map((city) => (
                        <li key={city.id} onClick={() => selectAddressCity(city)}>
                          {city.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="form-group visitor-switch-group">
                <label>Endereço principal</label>
                <div className="visitor-switch-row">
                  <span className={`visitor-switch-label ${!addressFormData.main ? 'active' : ''}`}>Não</span>
                  <label className="visitor-switch">
                    <input
                      type="checkbox"
                      name="main"
                      checked={!!addressFormData.main}
                      onChange={handleAddressFormChange}
                    />
                    <span className="visitor-switch-slider" />
                  </label>
                  <span className={`visitor-switch-label ${!!addressFormData.main ? 'active' : ''}`}>Sim</span>
                </div>
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSaveAddress}
                disabled={isSavingAddress}
              >
                {isSavingAddress ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </Modal>
        )}

        {canEditVisitorData && (
          <Modal
            isOpen={isPhoneModalOpen}
            closeModal={handleClosePhoneModal}
          >
            <h3>{editingPhoneId ? 'Editar telefone' : 'Adicionar telefone'}</h3>
            <div className="div-form-container">
              <div className="form-group" style={{ flexBasis: '100%', width: '100%' }}>
                <label>Nome</label>
                <input
                  type="text"
                  name="name"
                  value={phoneFormData.name}
                  onChange={handlePhoneFormChange}
                />
              </div>
              <div className="form-group">
                <label>Título</label>
                <input
                  type="text"
                  name="title"
                  value={phoneFormData.title}
                  onChange={handlePhoneFormChange}
                />
              </div>
              <div className="form-group">
                <label>Número</label>
                <FormattedInput
                  type="telefone"
                  name="number"
                  value={phoneFormData.number}
                  onChange={handlePhoneFormChange}
                />
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSavePhone}
                disabled={isSavingPhone}
              >
                {isSavingPhone ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </Modal>
        )}

        {canShowAuthorizationAction && (
          <Modal
            isOpen={isAuthModalOpen}
            closeModal={closeAuthModal}
            title="Atualizar autorização"
          >
            <div className="auth-modal-grid">
              <div className="auth-column">
                <h4>Serviço Social</h4>
                {visitor?.social_worker_authorization && (
                  <p className="auth-status-info">
                    Status atual: <strong>{visitor.social_worker_authorization}</strong>
                  </p>
                )}
                <select
                  name="social_worker_authorization"
                  value={authForm.social_worker_authorization}
                  onChange={handleAuthChange}
                >
                  <option value="Sem resposta">Sem resposta</option>
                  <option value="Autorizado">Autorizado</option>
                  <option value="Não autorizado">Não autorizado</option>
                </select>

                {authForm.social_worker_authorization === 'Não autorizado' && (
                  <div className="form-group auth-textarea-group">
                    <label>Motivo (Serviço Social)</label>
                    <textarea
                      name="social_worker_motive"
                      value={authForm.social_worker_motive}
                      onChange={handleAuthChange}
                    />
                    {authErrors.social_worker_motive && (
                      <span className="visitante-error">{authErrors.social_worker_motive}</span>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="btn-visitor-secondary"
                onClick={handleSaveAuthorization}
                disabled={isSavingAuth}
              >
                {isSavingAuth ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </Modal>
        )}

      </div >
    </div >
  );
}

export default VisitantesDetalhes;
const normalizeUpperNoAccent = (inputValue) => String(inputValue || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toUpperCase();
